import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {getChartColor} from '../../utils/score-chart.utils';

@Component({
  selector: 'app-score-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './score-bar.component.html',
})
export class ScoreBarComponent {
  readonly percentage = input.required<number>();
  readonly color = input<string>();
  readonly testId = input<string>();

  protected readonly fillColor = computed(() => this.color() ?? getChartColor(this.percentage()));
}
